import { memo } from 'react'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'

const FilterOption = memo(({ uniqueName, id, productName, productChecked, onChange }) => {
    const checkboxId = `${uniqueName}-${id}`
    return (
        <div className="tw:flex tw:items-center tw:gap-2 tw:mb-2">
            <Checkbox
                id={checkboxId}
                checked={productChecked}
                onCheckedChange={(checked) => onChange({ target: { checked } })}
            />
            <Label htmlFor={checkboxId} className="tw:capitalize tw:cursor-pointer tw:text-sm">
                {productName}
            </Label>
        </div>
    )
})

FilterOption.displayName = 'FilterOption'
export default FilterOption
